<template>
  <div>
    <v-layout row container justify-center>
      <v-dialog v-model="dialog" persistent max-width="1500">
        <v-card light class="pr-5 pl-5 pt-4 pb-4">
          <div v-if="loadingForm" class="spacing-top">
            <v-flex offset-xs5 pa-5>
              <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
            </v-flex>
          </div>
          <div v-else>
            <span class="subheadline" v-if="!isEditing && $store.getters.isClubRole">Creación información de pago</span>
            <span class="subheadline" v-else-if="canEdit && $store.getters.isClubRole">Edición información de pago</span>
            <span class="subheadline" v-else>Información de pago de {{ jugadorDisplay }}</span>

            <v-layout row wrap>
              <v-flex :xs2="mostrarFoto ? true : false" v-if="mostrarFoto">
                <div class="personal-photo">
                  <v-img :src="photo" max-height="158px" contain></v-img>
                </div>
              </v-flex>
              <v-flex :xs10="mostrarFoto ? true : false" :xs12="!mostrarFoto ? true : false">
                <v-layout row wrap class="item-group">
                  <v-flex xs12>
                      <v-autocomplete v-if="canEdit && $store.getters.isClubRole" v-model="$v.jugador.$model" label="Jugador" :error-messages="this.getRequiredErrors('jugador')"
                                  :items="jugadores" :item-text="item=> item.player.firstName + ' ' + item.player.lastName + ' - DNI: ' + item.player.dni"
                                  item-value="player.pk" :readonly="!canEdit"></v-autocomplete>
                      <v-text-field v-else :value="jugadorDisplay" label="Jugador" readonly></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                      <v-autocomplete v-if="canEdit && $store.getters.isClubRole" :disabled="disabledConceptos" v-model="$v.condicionSalarial.$model"
                      label="Concepto" :error-messages="this.getRequiredErrors('condicionSalarial')"
                                  :items="condiciones" item-text="conceptoDisplay" item-value="id" :readonly="!canEdit"></v-autocomplete>
                      <v-text-field v-else :value="condicionSalarial.conceptoDisplay" label="Concepto" readonly></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                      <v-autocomplete v-if="canEdit && $store.getters.isClubRole" v-model="moneda" label="Moneda" :error-messages="this.getRequiredErrors('moneda')"
                                  :items="monedas" readonly></v-autocomplete>
                      <v-text-field v-else :value="monedaDisplay" label="Moneda" readonly></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <span class="subheadline">Importe en pesos</span>
            <v-layout row class="item-group">
              <v-flex>
                  <v-currency-field v-model="$v.bruto.$model" label="Importe bruto" :error-messages="this.getRequiredErrors('bruto')"
                  :readonly="!canEdit || $store.getters.isSafRole"></v-currency-field>
              </v-flex>
              <v-flex>
                  <v-currency-field v-model="$v.seguridadSocial.$model" label="Seguridad Social" :readonly="!canEdit || $store.getters.isSafRole"></v-currency-field>
              </v-flex>
              <v-flex>
                  <v-currency-field v-model="$v.obraSocial.$model" label="Obra Social" :readonly="!canEdit || $store.getters.isSafRole"></v-currency-field>
              </v-flex>
              <v-flex>
                  <v-currency-field v-model="$v.sindicato.$model" label="Sindicato" :readonly="!canEdit || $store.getters.isSafRole"></v-currency-field>
              </v-flex>
              <v-flex>
                  <v-currency-field v-model="$v.ganancias.$model" label="Ganancias" :readonly="!canEdit || $store.getters.isSafRole"></v-currency-field>
              </v-flex>
              <v-flex>
                  <v-currency-field v-model="$v.otrosDescuentos.$model" label="Otros descuentos" :readonly="!canEdit || $store.getters.isSafRole"></v-currency-field>
              </v-flex>
              <v-flex>
                  <v-currency-field v-if="canEdit && $store.getters.isClubRole" v-model="$v.neto.$model" label="Importe neto"></v-currency-field>
                  <v-currency-field v-else :value="importeNetoPesos" label="Importe neto" readonly></v-currency-field>
              </v-flex>
            </v-layout>
            <span class="subheadline" v-if="moneda != ARS && moneda">
              Importe en moneda extranjera
              <v-tooltip bottom v-if="$store.getters.isSafRole">
                <v-icon slot="activator" color="primary">info</v-icon>
                <span>Descripción de Tipo de Cambio:
                  <br/>
                  {{ condicionSalarial.descripcionTipoDeCambio }}</span>
              </v-tooltip>
            </span>
            <v-layout row wrap class="item-group" v-if="moneda != ARS && moneda">
              <v-flex xs3>
                  <v-currency-field v-model="$v.tipoDeCambio.$model" label="Tipo de cambio" :readonly="!canEdit || $store.getters.isSafRole"
                  :error-messages="this.getRequiredErrors('tipoDeCambio')"></v-currency-field>
              </v-flex>
              <v-flex xs3>
                  <DatePickerForm v-model="$v.fechaDePago.$model" required label="Fecha de pago" :readonly="!canEdit || $store.getters.isSafRole"
                  :error-messages="this.getRequiredErrors('fechaDePago')"></DatePickerForm>
              </v-flex>
              <v-flex xs3>
                  <v-currency-field v-model="brutoExtValue" label="Importe Bruto" readonly></v-currency-field>
              </v-flex>
              <v-flex xs3>
                  <v-currency-field v-model="netoExtValue" label="Importe Neto" readonly></v-currency-field>
              </v-flex>
            </v-layout>
            <v-switch @change="cambiarModificarAdjuntos()" v-model="clubPuedeBorrarAdjuntos" :disbled="saving"
              label="Club puede borrar adjuntos" color="primary lighten-2" :disabled="!canEdit" v-if="$store.getters.isSafRole"></v-switch>
            <div v-if="pagoId">
              <span class="subheadline">Detalle de pagos</span>
              <div class="item-group">
                <detalle-de-pago :pagoId="pagoId" :canEdit="canEdit" :clubPuedeBorrarAdjuntos="clubPuedeBorrarAdjuntos"></detalle-de-pago>
              </div>
            </div>
            <div v-if="pagoId">
              <span class="subheadline">Observaciones</span>
              <div class="item-group">
                <pago-observaciones :canAdd="canAddObservaciones" ref="observaciones" :pagoId="pagoId" :canEdit="canEdit" v-if="isEditing"
                :tieneNotificaciones="tieneNotificaciones" @observacionCreada="refreshPago"/>
              </div>
            </div>
            <ConfirmationDialog :function-yes="bindingFunction" ref="confirmLeave" title="Abandonar formulario"
              :text="textConfirmDialog"></ConfirmationDialog>
            <v-card-actions v-if="$store.getters.isClubRole">
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="confirmLeave">Volver</v-btn>
              <v-btn color="primary" @click="preSubmit" v-if="canEdit && puedeGuardar" :disabled="saving">{{ isEditing ? 'Guardar' : 'Crear' }}</v-btn>
            </v-card-actions>
            <v-card-actions v-else>
              <v-btn color="primary" @click="cerrarModal">Volver</v-btn>
              <v-spacer></v-spacer>
              <div v-if="canEdit">
                <v-btn color="success" @click="aprobarPago">Aprobar pago</v-btn>
                <v-btn color="error" @click="rechazarPago">Rechazar pago</v-btn>
              </div>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>

</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import PagoObservaciones from './PagoObservaciones.vue'
import DetalleDePago from './DetalleDePago'
import DatePickerForm from '../../../common/ui/DatePickerForm'
import Constants from '../../../common/constants'

const DOLAR_DEFAULT = 100

export default {
  mixins: [validationMixin, createEntityMixin],

  validations: {
    condicionSalarial: { required },
    jugador: { required },
    moneda: { required },
    bruto: { required },
    seguridadSocial: {},
    obraSocial: {},
    sindicato: {},
    ganancias: {},
    otrosDescuentos: {},
    neto: {},
    tipoDeCambio: {
      required: requiredIf(function (tipoDeCambio) {
        return this.moneda !== this.ARS
      }) },
    fechaDePago: {
      required: requiredIf(function (fechaDePago) {
        return this.moneda !== this.ARS
      }) }
  },

  components: {
    ConfirmationDialog,
    PagoObservaciones,
    DatePickerForm,
    DetalleDePago
  },

  props: {
    dialog: Boolean,
    pagoId: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      loadingCondiciones: false,
      bindingFunction: null,
      ARS: Constants.ARS,
      USD: Constants.USD,
      EUR: Constants.EUR,
      BRUTO: Constants.BRUTO,
      NETO: Constants.NETO,
      monedas: [
        {
          text: 'ARS',
          value: Constants.ARS
        },
        {
          text: 'USD',
          value: Constants.USD
        },
        {
          text: 'EUR',
          value: Constants.EUR
        }
      ],
      condicionSalarial: '',
      condiciones: [],
      jugador: null,
      jugadores: [],
      moneda: null,
      brutoValue: 0,
      netoValue: 0,
      brutoExtValue: 0,
      netoExtValue: 0,
      seguridadSocial: null,
      obraSocial: null,
      sindicato: null,
      ganancias: null,
      otrosDescuentos: null,
      observaciones: null,
      createPath: 'pago/new',
      editPath: `pago/editar/${this.pagoId}`,
      viewPath: `pago/${this.pagoId}`,
      saving: false,
      tipoDeCambio: null,
      fechaDePago: null,
      loadingForm: false,
      canEdit: true,
      importeNetoPesos: null,
      jugadorDisplay: null,
      inputDeImporteSeleccionado: {
        input: null,
        value: 0
      },
      tieneNotificaciones: false,
      photo: null,
      textConfirmDialog: null
    }
  },

  methods: {
    cambiarModificarAdjuntos () {
      const puedeBorrar = this.clubPuedeBorrarAdjuntos ? 1 : 0
      const path = `pago/${this.pagoId}/club-puede-borrar-adjuntos/${puedeBorrar}`
      this.saving = true
      this.axios
        .put(path)
        .then(() => {
          this.saving = false
        })
        .catch(error => {
          this.saving = false
          this.clubPuedeBorrarAdjuntos = puedeBorrar ? 0 : 1
          this.$store.commit('setErrorMsg', error)
        })
    },
    postSuccessfulSubmit (response) {
      if (this.isEditing) {
        this.cerrarModal()
      } else {
        this.$emit('updatedPago')
        this.$emit('cerrarModal', response.data.pk)
      }
    },
    refreshPago () {
      this.fetchData()
    },
    aprobarPago () {
      this.$emit('aprobarPago', this.pagoId)
    },
    rechazarPago () {
      this.$emit('rechazarPago', this.pagoId)
    },
    cerrarModal () {
      this.$emit('updatedPago')
      this.$emit('cerrarModal', false)
    },
    fetchData () {
      this.loadingForm = true
      this.axios
        .get(this.viewPath)
        .then(response => {
          this.setData(response.data)
          this.marcarObservacionesDePagoLeidas()
          this.loadingForm = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.loadingForm = false
        })
    },

    fetchJugadores () {
      let jugadoresPath
      if (this.isEditing) {
        jugadoresPath = `/informe/${this.informeId}/jugadores/${this.pagoId}`
      } else {
        jugadoresPath = `/informe/${this.informeId}/jugadores`
      }
      this.axios
        .get(jugadoresPath)
        .then(response => {
          this.loadingCondiciones = false
          this.jugadores = response.data
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.loadingCondiciones = false
        })
    },

    setData (data) {
      this.photo = data.jugador.photo
      this.canEdit = data.canEdit
      this.canAddObservaciones = data.canAddObservacion
      this.jugador = data.jugador.pk
      this.condicionSalarial = data.condicionSalarial
      this.obraSocial = Number(data.obraSocial)
      this.sindicato = Number(data.sindicato)
      this.otrosDescuentos = Number(data.otrosDescuentos)
      this.seguridadSocial = Number(data.seguridadSocial)
      this.ganancias = Number(data.ganancias)
      this.bruto = Number(data.importeBruto)
      this.moneda = data.moneda
      this.monedaDisplay = data.monedaDisplay
      this.jugadorDisplay = `${data.jugador.firstName} ${data.jugador.lastName}`
      this.importeNetoPesos = Number(data.importeNeto)
      this.tipoDeCambio = Number(data.tipoDeCambio)
      this.fechaDePago = this.formatDateFromAPI(data.fechaDePago)
      this.tieneNotificaciones = data.tieneNotificaciones
      this.clubPuedeBorrarAdjuntos = data.clubPuedeBorrarAdjuntos
    },
    convertToCurrency (amount) {
      return Number(amount).toFixed(2)
    },
    getPayload () {
      let payload = {
        informe: this.informeId,
        jugador: this.jugador,
        condicionSalarial: this.condicionSalarial.id || this.condicionSalarial,
        moneda: this.moneda,
        importeBruto: this.convertToCurrency(this.brutoValue),
        seguridadSocial: this.convertToCurrency(this.seguridadSocial),
        obraSocial: this.convertToCurrency(this.obraSocial),
        sindicato: this.convertToCurrency(this.sindicato),
        ganancias: this.convertToCurrency(this.ganancias),
        otrosDescuentos: this.convertToCurrency(this.otrosDescuentos)
      }

      if (payload.moneda !== Constants.ARS) {
        payload.tipoDeCambio = this.convertToCurrency(this.tipoDeCambio)
        payload.fechaDePago = this.fechaDePago
      }
      return payload
    },
    confirmLeave () {
      if (this.isModified) {
        this.bindingFunction = this.cerrarModal
        this.textConfirmDialog = 'Se perderán los cambios del formulario actual, ¿desea continuar?'
        this.$refs.confirmLeave.openDialog()
      } else {
        this.cerrarModal()
      }
    },

    preSubmit () {
      this.$v.$touch()
      if (this.observacionSinGuardar) {
        this.bindingFunction = this.submit
        this.textConfirmDialog = 'Tiene observaciones sin guardar, ¿desea continuar?'
        this.$refs.confirmLeave.openDialog()
      } else {
        this.submit()
      }
    },
    isValidForm () {
      return !this.$v.$invalid
    },
    resetImportes () {
      this.bruto = this.bruto ? this.bruto : null
      this.obraSocial = 0
      this.sindicato = 0
      this.otrosDescuentos = 0
      this.seguridadSocial = 0
      this.ganancias = 0
      this.tipoDeCambio = DOLAR_DEFAULT
    },
    setearMonedaDesdeCondicion () {
      const condicion = this.condiciones.find(c => c.id === this.condicionSalarial)
      this.moneda = Number(condicion.moneda)
      let importe = Number(condicion.importeMensual)
      this.inputDeImporteSeleccionado.value = importe

      if (this.moneda === this.ARS) {
        if (condicion.tipoImporte === this.BRUTO) {
          this.inputDeImporteSeleccionado.input = this.setearBruto
        } else {
          this.inputDeImporteSeleccionado.input = this.setearDesdeNeto
        }
      } else {
        if (condicion.tipoImporte === this.BRUTO) {
          this.inputDeImporteSeleccionado.input = this.setearDesdeBrutoExt
        } else {
          this.inputDeImporteSeleccionado.input = this.setearDesdeNetoExt
        }
      }
      this.inputDeImporteSeleccionado.input(importe)
    },
    parseCurrencyString (string) {
      return Number(String(string).replace(/,/g, ''))
    },
    setearBruto (bruto) {
      bruto = this.parseCurrencyString(bruto)
      this.brutoValue = bruto
      this.netoValue = bruto - this.descuentos
      this.brutoExtValue = bruto / Number(this.tipoDeCambio)
      this.netoExtValue = this.netoValue / Number(this.tipoDeCambio)
    },
    setearDesdeNeto (importe) {
      importe = this.parseCurrencyString(importe)
      this.brutoValue = Number(importe) + this.descuentos
      this.setearBruto(this.brutoValue)
    }
  },

  computed: {
    informeId () {
      return this.$route.params.id
    },
    puedeGuardar () {
      return this.$v.$anyDirty
    },
    mostrarFoto () {
      return this.photo && this.isEditing && (!this.canEdit || this.$store.getters.isSafRole)
    },
    observacionSinGuardar () {
      if (this.canEdit && this.isEditing && this.canAddObservaciones) {
        const observacionTexto = this.$refs.observaciones.$refs.observaciones.$refs.observaciones.$refs.observacionNew.$refs.observacionText.value || ''
        return observacionTexto !== ''
      }
      return false
    },
    isModified () {
      return this.$v.$anyDirty || this.observacionSinGuardar
    },
    disabledConceptos () {
      return this.jugador == null && !this.loadingCondiciones
    },
    descuentos () {
      const descuentos = [this.seguridadSocial, this.obraSocial, this.sindicato, this.ganancias, this.otrosDescuentos]
      return descuentos.map(descuento => Number(descuento)).reduce((prev, current) => (prev += current))
    },
    bruto: {
      get: function () {
        return this.brutoValue
      },
      set:
        function (importe) {
          this.inputDeImporteSeleccionado.value = importe
          this.inputDeImporteSeleccionado.input = this.setearBruto
          this.setearBruto(importe)
        }
    },
    neto: {
      get: function () {
        return this.netoValue
      },
      set: function (importe) {
        this.inputDeImporteSeleccionado.value = importe
        this.inputDeImporteSeleccionado.input = this.setearDesdeNeto
        this.setearDesdeNeto(importe)
      }
    },
    isEditing () {
      return this.pagoId != null
    }
  },

  created () {
    if (this.$store.getters.isClubRole) {
      this.fetchJugadores()
    }
  },

  watch: {
    jugador: function () {
      if (this.$store.getters.isSafRole) return
      this.concepto = ''
      this.moneda = null

      let condicionesPath = `/condiciones/pago/${this.jugador}/${this.informeId}`

      if (this.pagoId) {
        condicionesPath = `${condicionesPath}/${this.pagoId}`
      }

      this.loadingCondiciones = true
      this.axios
        .get(condicionesPath)
        .then(response => {
          this.loadingCondiciones = false
          this.condiciones = response.data
          this.setearMonedaDesdeCondicion()
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.loadingCondiciones = false
        })
    },
    condicionSalarial: function () {
      if (this.loadingCondiciones) {
        this.moneda = this.condicionSalarial.moneda
        return
      }
      if (this.$store.getters.isClubRole) {
        this.resetImportes()
        this.setearMonedaDesdeCondicion()
      }
    },
    descuentos: function () {
      const importe = this.inputDeImporteSeleccionado.value
      this.inputDeImporteSeleccionado.input(importe)
    },
    tipoDeCambio: function () {
      const importe = this.inputDeImporteSeleccionado.value
      this.inputDeImporteSeleccionado.input(importe)
    }
  }

}
</script>
<style scoped>
  .personal-photo {
    background-color: rgb(223, 223, 223);
    border-color: rgb(185, 184, 184);
    border-radius: 5px;
    border-style: solid;
    margin-right: 0.5em;
  }
  .item-group{
    border-style: solid;
    border-radius: 5px;
    background-color: rgb(223, 223, 223);
    border-color: rgb(185, 184, 184);
    border-spacing: 1em;
    padding-left: 1.5em;
    padding-right: 1.5em;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    margin-bottom: 2em;
  }
  .subheadline {
    color: lightslategray;
    font-size: 1.6em;
    color: rgb(60, 145, 197);
    padding-top: 1.5em;
    margin-top: 2em;
  }
</style>
